import { render, staticRenderFns } from "./StepTest.vue?vue&type=template&id=b2e6b94c&scoped=true"
import script from "./StepTest.vue?vue&type=script&lang=js"
export * from "./StepTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e6b94c",
  null
  
)

export default component.exports